import type {
  GraphMember,
  TreeNamePreference,
} from '@/contexts/FamilyGraphContext';

const usable = (
  value: string | null | undefined,
): string | null => {
  const normalized = value?.trim() ?? '';

  if (
    !normalized ||
    normalized.toLowerCase() === 'unknown'
  ) {
    return null;
  }

  return normalized;
};

export function resolveTreeDisplayName(
  member: Pick<
    GraphMember,
    'name' | 'nickname' | 'treeNamePreference'
  >,
  fallback = 'Family Member',
): string {
  const realName = usable(member.name);
  const nickname = usable(member.nickname);

  if (
    member.treeNamePreference === 'nickname' &&
    nickname
  ) {
    return nickname;
  }

  return realName ?? nickname ?? fallback;
}

export function resolveTreeFirstName(
  member: Pick<
    GraphMember,
    'name' | 'nickname' | 'treeNamePreference'
  >,
  fallback = 'Family Member',
): string {
  const displayName = resolveTreeDisplayName(
    member,
    fallback,
  );

  return displayName.split(/\s+/)[0] || displayName;
}
